import {
  Box,
  ClickAwayListener,
  Divider,
  IconButton,
  List,
  Popper,
} from '@mui/material';
import LastPageIcon from '@mui/icons-material/LastPage';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import ROUTES from '@src/constants/route';
import { useCheckProjectRoute } from '@src/hooks/useCheckDubbingRoute';
import { SIDEBAR_BOX_SHADOW } from '@src/styles/config';
import smallLogoAiVoice from '@src/assets/logo/small-logo-AiVoice-new.svg';
import { StyledSidebarNew, StyledSidebarTooltip } from './index.style';
import UserInfo from '../UserInfo';
import VoucherAds from '../VoucherAds';
import ProductSwitcher from '../ProductSwitcher';

const SmallSidebar = ({
  createLinks,
  sidebarRoute,
  ipLocation,
  isExpiredPackage,
  renderSubMenuSupport,
  handleOpenSidebar,
  vouchers,
  showAutoRenewalBanner,
  useHeaderBanner,
  headerVoucher,
  voucherSidebar,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [supportMenuAnchor, setSupportMenuAnchor] = useState(null);
  const isDetailProjectPage = useCheckProjectRoute();

  const handleRedirectToStudio = () => {
    if (isDetailProjectPage) {
      history.push(ROUTES.TTS);
    }
  };

  const renderSmallSideBarItems = (props) => (
    <div
      className={classNames('sidebar-wrapper', {
        'hidden-scrollbar': !isDetailProjectPage,
        'padding-0': isDetailProjectPage,
      })}
    >
      <ProductSwitcher expanded={false} />
      <List
        className={classNames('list', {
          'list-multi-block-uiv2': isDetailProjectPage,
        })}
        style={{ paddingBottom: '0px' }}
      >
        {createLinks(sidebarRoute, props)}
      </List>

      {supportMenuAnchor && (
        <ClickAwayListener onClickAway={() => setSupportMenuAnchor(null)}>
          <Popper
            open={Boolean(supportMenuAnchor)}
            anchorEl={supportMenuAnchor}
            onClose={() => setSupportMenuAnchor(null)}
            placement="right"
            style={{
              zIndex: 1299,
              boxShadow: SIDEBAR_BOX_SHADOW,
              borderRadius: 12,
              overflow: 'hidden',
            }}
            modifiers={[{ name: 'offset', options: { offset: [0, 12] } }]}
          >
            {renderSubMenuSupport({
              props,
              className: 'small-sub-menu-wrapper',
              itemClassName: 'small-sub-menu-item',
            })}
          </Popper>
        </ClickAwayListener>
      )}
    </div>
  );
  return (
    <StyledSidebarNew
      useHeaderBanner={useHeaderBanner}
      headerVoucher={headerVoucher}
      isDetailProjectPage={isDetailProjectPage}
    >
      <div
        onClick={handleRedirectToStudio}
        role="button"
        tabIndex="-1"
        className="brand"
      >
        <img
          src={smallLogoAiVoice}
          alt="vbee tts logo"
          className="logo-img"
          width={108}
        />
      </div>
      <Divider />
      {renderSmallSideBarItems()}
      {!isDetailProjectPage && (
        <VoucherAds
          handleOpenSidebar={handleOpenSidebar}
          isSmallSidebar
          isExpiredPackage={isExpiredPackage}
          showAutoRenewalBanner={showAutoRenewalBanner}
          vouchers={vouchers}
          voucherSidebar={voucherSidebar}
        />
      )}

      <Divider />
      <Box className="footer-sidebar">
        <UserInfo smallSidebar ipLocation={ipLocation} />
        {!isDetailProjectPage && (
          <StyledSidebarTooltip title={t('expand')} placement="right">
            <IconButton onClick={handleOpenSidebar}>
              <LastPageIcon />
            </IconButton>
          </StyledSidebarTooltip>
        )}
      </Box>
    </StyledSidebarNew>
  );
};

export default SmallSidebar;
